export { default as AtlassianAccessLink } from './src/atlassian-access-link';
